import { AppStore } from '../../redux/appStore'
import { AppFormRelayImpl } from '@fusion-advantage/formrender'

export const subscribeAppFormRelay = (appStore: AppStore, appFormRelay: AppFormRelayImpl) => {
	let nextState = appStore.getState()
	return appStore.subscribe(() => {
		const prevState = nextState
		nextState = appStore.getState()
		if(prevState.render !== nextState.render) {
			appFormRelay.forwardUpdatedRenderState(nextState.render)
		}
	})
}
